__webpack_require__.p = "/tokens-add-new-view-button/account-setup/";